const windowsReqs = [
  { label: 'Operating System', value: 'Windows 7 or later (64-bit)' },
  { label: 'Processor', value: '1 GHz Intel processor or greater' },
  { label: 'RAM', value: '2 GB RAM (4 GB recommended)' },
  { label: 'Hard Disk Space', value: '1 GB free hard disk space' },
  { label: 'Display', value: '1024 x 768 resolution or higher' },
  { label: 'Internet Connection', value: 'Required for activation and updates' },
];

const macReqs = [
  { label: 'Operating System', value: 'macOS 10.13 or later' },
  { label: 'Processor', value: 'Intel Core 2 Duo or greater' },
  { label: 'RAM', value: '2 GB RAM (4 GB recommended)' },
  { label: 'Hard Disk Space', value: '1 GB free hard disk space' },
  { label: 'Display', value: '1024 x 768 resolution or higher' },
  { label: 'Internet Connection', value: 'Required for activation and updates' },
];

function ReqCard({ title, items }) {
  return (
    <div className="bg-white/10 backdrop-blur p-8 rounded-xl border border-white/20 shadow-sm">
      <h3 className="text-xl font-bold text-white mb-6 text-center">{title}</h3>
      <div className="space-y-4">
        {items.map((item) => (
          <div key={item.label}>
            <h4 className="font-semibold text-[#a5f3fc] mb-1">{item.label}</h4>
            <p className="text-white/90">{item.value}</p>
          </div>
        ))}
      </div>
    </div>
  );
}

export default function SystemRequirements() {
  return (
    <section className="py-20 bg-[#1a263d] text-white">
      <div className="container mx-auto px-4">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-white mb-6">System Requirements</h2>
        <div className="section-divider w-24 mx-auto mb-12" />
        <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto">
          <ReqCard title="Windows" items={windowsReqs} />
          <ReqCard title="macOS" items={macReqs} />
        </div>
      </div>
    </section>
  );
}
